import { useState } from "react";
import { useLanguage } from "../language/LanguageConfig";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Language } from "./context";

// 드롭다운 메뉴를 위한 스타일 컴포넌트
const NavLinkWithDropdown = styled.div`
  margin-left: 2rem;
  position: relative;
  display: flex;
  align-items: center;
  bottom: 1px;
`;

const DropdownButton = styled.button`
  background: none;
  border: none;
  color: #333;
  font-weight: 500;
  font-size: 1rem;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #22365c;
    transition: width 0.3s ease;
  }

  &:hover:after {
    width: 100%;
  }
`;

const DropdownIcon = styled.span`
  margin-left: 5px;
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: transform 0.3s ease;

  ${(props) =>
    props.$isOpen &&
    `
    transform: rotate(180deg);
  `}
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  min-width: 180px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 0.5rem 0;
  margin-top: 10px;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  transform: ${(props) =>
    props.$isOpen ? "translateY(0)" : "translateY(-10px)"};
  transition: all 0.3s ease;
  z-index: 200;
`;

const DropdownItem_2 = styled(Link)`
  display: block;
  padding: 0.75rem 1rem;
  color: #333;
  text-decoration: none;
  font-weight: 400;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: #f8f9fa;
    color: #22365c;
  }
`;

const DropdownItem = styled.button`
  display: block;
  padding: 0.75rem 1rem;
  color: #333;
  text-decoration: none;
  font-weight: 400;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: #f8f9fa;
    color: #22365c;
  }
`;

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const [DropdownOpen, setDropdownOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const LANGUAGE_LABELS = {
    [Language.KOREAN]: "KOR",
    [Language.ENGLISH]: "ENG",
    [Language.CHINESE]: "CN",
  };

  const buttons = Object.entries(LANGUAGE_LABELS).map(([code, label]) => ({
    code,
    label,
  }));

  const handleChangeLang = (code) => {
    if (lang == code) return;

    const segments = location.pathname.split("/");

    if (segments.length > 1) {
      segments[1] = code; // replace language code
      const newPath = segments.join("/") || "/";
      navigate(newPath);
    }
  };

  return (
    <NavLinkWithDropdown
      onMouseEnter={() => setDropdownOpen(true)}
      onMouseLeave={() => setDropdownOpen(false)}
    >
      <DropdownButton>
        {LANGUAGE_LABELS[lang] || "LANG"}
        <DropdownIcon $isOpen={DropdownOpen} />
      </DropdownButton>
      <DropdownMenu $isOpen={DropdownOpen}>
        {buttons.map(({ code, label }) => (
          <DropdownItem
            key={code}
            onClick={() => handleChangeLang(code)}
            disabled={lang == code}
            style={{ marginRight: "8px" }}
          >
            {label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </NavLinkWithDropdown>
  );
};

export default LanguageSwitcher;
